import { render, staticRenderFns } from "./FreightForwardingContract.vue?vue&type=template&id=71d8d1e1"
import script from "./FreightForwardingContract.vue?vue&type=script&lang=js"
export * from "./FreightForwardingContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports